 import React from 'react';
 import './Button.css'; // Za chwilę stworzymy ten plik

 // Używamy "ComponentPropsWithoutRef" z Reacta, aby nasz komponent
 // mógł przyjmować wszystkie standardowe właściwości przycisku (np. onClick, type, disabled)
 type ButtonProps = React.ComponentPropsWithoutRef<'button'> & {
   variant?: 'primary' | 'secondary'; // Opcjonalny wariant wyglądu
 };

 export const Button = ({ children, className, variant = 'primary', ...props }: ButtonProps) => {
   // Łączymy bazową klasę CSS z dodatkowymi, przekazanymi z zewnątrz
   const buttonClasses = `btn ${variant === 'primary' ? 'btn-primary' : 'btn-secondary'} ${className || ''}`;

   return (
     <button className={buttonClasses} {...props}>
       {children}
     </button>
   );
 };